package com.havn.app.core.supabase

object HavnSupabaseConfig {
    val url = havnSupabaseUrl
    val anonKey = havnSupabasePublishableKey
    val environment = havnEnvironmentName
    val appReviewEmail = havnAppReviewEmail
    val appReviewCode = havnAppReviewCode
    const val propertyPhotosBucket = "property-photos"
}

expect val havnEnvironmentName: String
expect val havnSupabaseUrl: String
expect val havnSupabasePublishableKey: String
expect val havnAppReviewEmail: String
expect val havnAppReviewCode: String
expect val havnMapKitJsToken: String
expect val havnAuthRedirectScheme: String
expect val havnAuthRedirectHost: String
